<template>
  <v-row class="mx-1 mt-8">
    <v-row class="ma-0">
      <v-col v-if="showGraphs.wlan0" cols="12">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayRajantData.wlan0.no.length !== 0"
            :name="'wlan0noise'"
            :first-array="allArrayRajantData.wlan0.no"
            :title="t('title.noiseLevel') + ` < Wlan0 >`"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
      <v-col v-if="showGraphs.wlan1" cols="12">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayRajantData.wlan1.no.length !== 0"
            :name="'wlan1noise'"
            :first-array="allArrayRajantData.wlan1.no"
            :title="t('title.noiseLevel') + ` < Wlan1 >`"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
      <v-col v-if="showGraphs.wlan2" cols="12">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayRajantData.wlan2.no.length !== 0"
            :name="'wlan2noise'"
            :first-array="allArrayRajantData.wlan2.no"
            :title="t('title.noiseLevel') + ` < Wlan2 >`"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
      <v-col v-if="showGraphs.wlan3" cols="12">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayRajantData.wlan3.no.length !== 0"
            :name="'wlan3noise'"
            :first-array="allArrayRajantData.wlan3.no"
            :title="t('title.noiseLevel') + ` < Wlan3 >`"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Temperature and Voltage Components -->

    <v-sheet color="transparent" width="100%">
      <v-col cols="12" v-if="showTempVolt.temp">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayTempVoltData.temp.length !== 0"
            :name="'temperature'"
            :first-array="allArrayTempVoltData.temp"
            :title="t('labels.temperature')"
            color="#000000"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
      <v-col cols="12" v-if="showTempVolt.volt">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayTempVoltData.volt.length !== 0"
            :name="'Voltage'"
            :first-array="allArrayTempVoltData.volt"
            :title="t('labels.voltage')"
            :color="COLOR.green"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>

      <!-- Cost Graph-->
      <v-col cols="12" v-if="showGraphs.cost">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayRajantData.costs.length !== 0"
            :name="'Cost'"
            :first-array="allArrayRajantData.costs"
            :title="t('labels.cost')"
            :color="COLOR.green"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
    </v-sheet>

    <!-- Wired Graph -->
    <v-col cols="12" v-if="showGraphs.wired">
      <v-sheet
        :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
        class="mb-4"
        color="bgtopology"
      >
        <CompareCharts
          v-if="allArrayRajantData.wired.rx.length !== 0"
          :subtitle="''"
          name-primary="rxGB"
          :first-array="allArrayRajantData.wired.rx"
          :color-first="COLOR.compare1"
          :color-second="COLOR.compare2"
          name-secundary="txGB"
          :second-array="allArrayRajantData.wired.tx"
          title="Wired Tx - Rx [eth0]"
          :typeChart="STRING_GENERAL.instamesh"
        />
        <v-sheet v-else class="text-center" color="transparent">
          <Prog_circular />
        </v-sheet>
      </v-sheet>
    </v-col>

    <v-sheet
      :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
      class="defaultCard"
      color="bgtopology"
    >
      <span class="subtitleDashboard">Clientes Wi-Fi</span>
      <EasyDataTable
        v-if="allArrayRajantData.wlanT.length > 0"
        table-class-name="customize-table"
        show-index
        :headers="HEAD_WLAN"
        :items="allArrayRajantData.wlanT"
      />
      <v-sheet v-else class="text-center" color="transparent">
        <Prog_circular />
      </v-sheet>
    </v-sheet>

    <v-row class="ma-0">
      <!-- <v-col v-if="showGraphs.wlanT" cols="12"> -->
        
      <!-- </v-col> -->

      <v-col
        v-if="showGraphs.wlan0"
        cols="12"
        sm="12"
        :md="showGraphs.wlan1 ? 6 : 12"
      >
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <CompareCharts
            v-if="allArrayRajantData.wlan0.rx.length !== 0"
            :subtitle="''"
            name-primary="rxGB"
            :first-array="allArrayRajantData.wlan0.rx"
            :color-first="COLOR.compare1"
            :color-second="COLOR.compare2"
            name-secundary="txGB"
            :second-array="allArrayRajantData.wlan0.tx"
            title="Wireless Tx - Rx [wlan0]"
            :typeChart="STRING_GENERAL.instamesh"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>

      <v-col v-if="showGraphs.wlan1" cols="12" sm="12" md="6" lg="6" xl="6">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <CompareCharts
            v-if="allArrayRajantData.wlan1.rx.length !== 0"
            :subtitle="''"
            name-primary="rxGB"
            :first-array="allArrayRajantData.wlan1.rx"
            :color-first="COLOR.compare1"
            :color-second="COLOR.compare2"
            name-secundary="txGB"
            :second-array="allArrayRajantData.wlan1.tx"
            title="Wireless Tx - Rx [wlan1]"
            :typeChart="STRING_GENERAL.instamesh"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>

      <v-col
        v-if="showGraphs.wlan2"
        cols="12"
        sm="12"
        :md="showGraphs.wlan3 ? 6 : 12"
      >
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <CompareCharts
            v-if="allArrayRajantData.wlan2.rx.length !== 0"
            :subtitle="''"
            name-primary="rxGB"
            :first-array="allArrayRajantData.wlan2.rx"
            :color-first="COLOR.compare1"
            :color-second="COLOR.compare2"
            name-secundary="txGB"
            :second-array="allArrayRajantData.wlan2.tx"
            title="Wireless Tx - Rx [wlan2]"
            :typeChart="STRING_GENERAL.instamesh"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>

      <v-col v-if="showGraphs.wlan3" cols="12" sm="12" md="6" lg="6" xl="6">
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <CompareCharts
            v-if="allArrayRajantData.wlan0.rx.length !== 0"
            :subtitle="''"
            name-primary="rxGB"
            :first-array="allArrayRajantData.wlan3.rx"
            :color-first="COLOR.compare1"
            :color-second="COLOR.compare2"
            name-secundary="txGB"
            :second-array="allArrayRajantData.wlan3.tx"
            title="Wireless Tx - Rx [wlan3]"
            :typeChart="STRING_GENERAL.instamesh"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
    </v-row>
  </v-row>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import SingleChart from "@/components/SmartLink/charts/SingleChart.vue";
import CompareCharts from "@/components/SmartLink/charts/CompareCharts.vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { HEAD_WLAN } from "@/constants/tableHeaders";
import { STRING_GENERAL } from "@/constants/labels";
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getRajantDataByIP,
  getTempVoltDataByIP,
} from "@/services/Smartlink/Graphs";

/********************************
 ********** INTERFACES **********
 *******************************/
import { TEMP_VOLT_GRAPHS } from "@/interfaces/SmartLink/Equipos";

const props = defineProps({
  ip: { required: true, type: String },
  // nameitem    : { required:true, type:String },
  typeitem: { required: true, type: String },
});

const params = { ip: props.ip };

/**
 * Capturamos los valores de la API: "getAllTempDataByIP"
 */
const getTempDataGraph = async () => {
  const allData = await getTempVoltDataByIP(params);

  console.log("allData", allData);
  if (allData.status === 400) {
    showTempVolt.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showTempVolt.value = allData.showGraphs;
    allArrayTempVoltData.value = allData.data;
  }
};

const showTempVolt = ref({
  temp: false,
  volt: false,
});

const allArrayTempVoltData = ref<TEMP_VOLT_GRAPHS>({
  volt: [],
  temp: [],
});

const showGraphs = ref({
  wlan0: false,
  wlan1: false,
  wlan2: false,
  wlan3: false,
  wlanT: false,
  wired: false,
  cost: false,
});
const allArrayRajantData = ref({
  wlan0: { rx: [], tx: [], no: [] },
  wlan1: { rx: [], tx: [], no: [] },
  wlan2: { rx: [], tx: [], no: [] },
  wlan3: { rx: [], tx: [], no: [] },
  wired: { rx: [], tx: [] },
  wlanT: [],
  costs: [],
});

/**
 * captura los valores de la API: "getAllWirelessDataByIP"
 */
const getWirelessDataGraph = async () => {
  const allData = await getRajantDataByIP(params);

  if (allData.status === 400) {
    showGraphs.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showGraphs.value = allData.showGraphs;
    allArrayRajantData.value = allData.data;
  }
};

onMounted(async () => {
  getTempDataGraph();
  getWirelessDataGraph();
});
</script>
